'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosWineglass = function IoIosWineglass(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.6 24.1v12.2h5.7v1.2h-12.5v-1.2h5.6v-12.2c0-1.7-1.6-3-3.1-4.3-0.7-0.4-1.3-1-1.8-1.4-2.1-2.2-2-4.1-2-5.6v-0.3c0-3.4 2.4-9.8 2.5-10h10c0.1 0.2 2.5 6.6 2.5 10v0.3c0 1.5 0.1 3.4-2 5.6-0.5 0.4-1.1 1-1.7 1.4-1.6 1.3-3.2 2.6-3.2 4.3z m-4.7-20.3c-0.4 1.2-1.6 4.9-2 7.5h12.2c-0.4-2.6-1.6-6.3-2-7.5h-8.2z' })
        )
    );
};

exports.default = IoIosWineglass;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-wineglass.js
// module id = 2321
// module chunks = 0